import { useTranslation } from 'react-i18next';
import { ROUTES } from '@/common/constants/routes';
import { useEmployeeDetails } from '@/common/contexts/user/UserDetailsContext';
import { Button, Flex, Heading } from '@coverflex-tech/hypernova';
import { useRouter } from 'expo-router';
import { NewCardSteps } from './components/NewCardSteps/NewCardSteps';

interface IProps {
  flow: 'single' | 'pin';
  isExpirationRenewal?: boolean;
}

export const CardActivated = ({ flow, isExpirationRenewal }: IProps) => {
  const { t } = useTranslation();
  const router = useRouter();
  const { employee } = useEmployeeDetails();

  return (
    <Flex flexDirection="column" alignItems="center" justifyContent="center">
      <Flex flexDirection="column" gap="lg" alignItems="flex-start">
        <Heading level={2}>
          {isExpirationRenewal
            ? t('activate_card.new_card.title')
            : t('activate_card.success.title')}
        </Heading>
        <NewCardSteps
          phoneNumber={flow === 'single' ? employee.phone : undefined}
          isExpirationRenewal={isExpirationRenewal}
        />
        <Button
          size="md"
          onClick={() => {
            router.dismissTo(ROUTES.CARD);
          }}
        >
          {t('general.navigation.close')}
        </Button>
      </Flex>
    </Flex>
  );
};
